document.addEventListener("DOMContentLoaded", ready);

function ready() {
const stickyElement = document.getElementById("df-sticky-element");
const chevron = document.getElementById("df-sticky-chevron");
const sommaire = document.getElementById("df-sticky-sommaire");
const stickyList = document.getElementById("df-sticky-list");

const mainMenu = document.getElementById('main-menu');

// Vérifier si l'élément existe
if (stickyElement && mainMenu) {
    const height = mainMenu.getBoundingClientRect().height; // Hauteur visible, en tenant compte des transformations
    // Modifier la propriété CSS "top" pour lui attribuer 92px
    stickyElement.style.top = height+'px';


// Fonction pour rétrécir ou étendre le sticky
function toggleSticky() {
    stickyElement.classList.toggle("shrunk");
}

// Cacher la liste et rétrécir le sticky lorsque l'un des éléments de la liste est cliqué
const items = stickyList.getElementsByTagName("li");
for (let item of items) {
    item.addEventListener("click", () => {
        toggleSticky(); // Réduire le sticky
    });
}

// Rétablir la taille et afficher la liste lorsque le chevron est cliqué
chevron.addEventListener("click", () => {
    toggleSticky(); // Agrandir ou réduire le sticky
});

// Rétablir la taille et afficher la liste lorsque "Sommaire" est cliqué
sommaire.addEventListener("click", () => {
    toggleSticky(); // Agrandir ou réduire le sticky
});

// Écouter l'événement de défilement
window.addEventListener("scroll", () => {
    const stickyRect = stickyElement.getBoundingClientRect();

    // Vérifier si l'élément est stické (lorsque le haut de l'élément atteint le haut de la fenêtre)
    if (stickyRect.top <= height && stickyRect.bottom > 0) {
        stickyElement.classList.add("df-stick-visible");
    } else {
        stickyElement.classList.remove("df-stick-visible");
    }
});


}}
